<template>
    <div id="ag-grid-demo">
        <vx-card class="p-4 mb-6">
            <div class="flex flex-wrap items-center justify-between mb-10">
                <div class="flex items-center">
                    <h4 style="margin-left: 10px">Good Issue Vendor</h4>
                </div>
            </div>

            <ag-grid-vue
                :gridOptions="gridOptions"
                class="my-4 ag-theme-material w-100 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="outbounds"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                :pagination="true"
                :suppressPaginationPanel="true"
                :paginationPageSize="paginationPageSize"
                rowSelection="single"
                @selection-changed="onSelectionChanged"
                @rowDoubleClicked="processOnDblClick"
                @grid-ready="onGridReady"
            >
            </ag-grid-vue>

            <p class="text-right">
                <b>
                    Showing {{ currentPage * paginationPageSize - (paginationPageSize - 1) }} to {{ outbounds.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : outbounds.length }} of
                    {{ outbounds.length }} total entries
                </b>
            </p>

            <vs-pagination
                :total="totalPages"
                :max="maxPageNumbers"
                v-model="currentPage"
            />
        </vx-card>

        <vs-prompt
            @accept="processItem"
            :active.sync="warehouseSelectionModal"
            title="Select Warehouse"
            :is-valid="warehouse.form.warehouse_id ? true : false"
        >
            <div class="con-exemple-prompt">
                <label class="vs-input--label">Warehouse</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="warehouse.form.warehouse_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, warehouse)"
                    placeholder="Select Warehouse"
                >
                    <vs-select-item
                        v-for="(item, index) in warehouse.data"
                        :key="index"
                        :value="item.id"
                        :text="item.warehouses_code"
                    />
                </vs-select>
            </div>
        </vs-prompt>
    </div>
</template>

<script>
    import { AgGridVue } from "ag-grid-vue";
    import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
    import vSelect from "vue-select";
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";

    export default {
        components: {
            vSelect,
            AgGridVue,
            flatPickr,
        },
        data() {
            return {
                maxPageNumbers: 7,
                gridOptions: {},
                gridApi: null,
                outbounds: [],
                columnDefs: null,
                defaultColDef: {
                    sortable: true,
                    editable: false,
                    resizable: true,
                    suppressMenu: true,
                    autoHeight: true,
                    wrapText: true
                },
                selectedId: null,
                isLoading: false,

                warehouse: {
                    data: [],
                    loading: false,
                    endpoint: "master/warehouses",
                    objectKey: "warehouses_code",
                    form: {
                        warehouse_id: ''
                    }
                },
                warehouseSelectionModal: false,
            };
        },

        computed: {
            paginationPageSize() {
                if(this.gridApi) return this.gridApi.paginationGetPageSize()
                else return 50
            },
            totalPages() {
                if(this.gridApi) return this.gridApi.paginationGetTotalPages()
                else return 0
            },
            currentPage: {
                get() {
                    if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
                    else return 1
                },
                set(val) {
                    this.gridApi.paginationGoToPage(val - 1);
                }
            }
        },

        watch: {
            isLoading: function () {
                if (this.isLoading) {
                    this.$vs.loading();
                } else {
                    this.$vs.loading.close();
                }
            },

            currentPage() {
                this.fetchData();
            },
        },
        methods: {
            onSelectionChanged() {
                var selectedRows = this.gridApi.getSelectedRows();
                var selectedRowsString = "";
                selectedRows.forEach(function (selectedRow, index) {
                    if (index !== 0) {
                        selectedRowsString += ", ";
                    }
                    selectedRowsString += selectedRow.id;
                });
                this.selectedId = selectedRowsString;
            },

            refreshData() {
                this.fetchData();
            },

            processOnDblClick() {
                this.openWarehouseSelection()
            },

            processOnClick(event) {
                const itemId = event.target.dataset.itemid
                if(itemId) this.selectedId = itemId

                this.openWarehouseSelection()
            },

            openWarehouseSelection() {
                this.isLoading = true;

                this.fetchDropdowns().then(() => {
                    this.isLoading = false;

                    this.warehouseSelectionModal = true
                }).catch(() => {
                    this.isLoading = false;

                    this.$vs.dialog({
                        type: "confirm",
                        color: "danger",
                        title: "Server Error",
                        text: "Try again?",
                        accept: () => {
                            this.openWarehouseSelection();
                        },
                        acceptText: "Yes",
                        cancelText: "No",
                    });
                });
            },

            fetchData() {
                this.isLoading = true;

                this.$http.get('/tvd/outbound/deliveryorder/outbound', {
                    params: {
                        page: this.currentPage
                    }
                }).then(res => {
                    this.outbounds = res.data.data;
                    this.isLoading = false;
                }).catch(() => {
                    this.isLoading = false;

                    this.$vs.dialog({
                        type: "confirm",
                        color: "danger",
                        title: "Server Error",
                        text: "Try again?",
                        accept: () => {
                            this.refreshData();
                        },
                        acceptText: "Yes",
                        cancelText: "No",
                    });

                    return;
                }); 
            },

            fetchDropdowns() {
                return this.$http.post("/master/warehouses").then(res => {
                    this.warehouse.data = res.data.data;
                });
            },

            processItem() {
                this.warehouseSelectionModal = false
                
                setTimeout(() => {
                    this.$router.push({
                        name: "outbound-delivery-good-issue-vendor-commit",
                        params: {
                            outbound_id: this.selectedId,
                            warehouse_id: this.warehouse.form.warehouse_id
                        },
                    });
                }, 250)
            },

            onGridReady(params) {
                params.api.sizeColumnsToFit();

                window.addEventListener('resize', () => {
                    params.api.sizeColumnsToFit();
                });
            }
        },

        mounted() {
            this.fetchData();
            this.gridApi = this.gridOptions.api;
        },

        beforeMount() {
            this.columnDefs = [
                {
                    headerName: "Reference",
                    field: "outbound_reference",
                    filter: true,
                    flex: 0.1,
                },
                {
                    headerName: "Product",
                    field: "details",
                    flex: 1,
                    cellRenderer: params => {
                        const products = params.value

                        let cell = ``
                        products.forEach(item => {
                            cell = `
                                ${cell}
                                <li><span class="font-bold text-lg">[${item.committed_qty}/${item.base_qty}]</span> ${item.product.product_code}</li>
                            `
                        })

                        return `
                            <ul>
                                ${cell}
                            </ul>
                        `
                    }
                },
                {
                    headerName: "Status",
                    field: "status",
                    cellRenderer: params => {
                        const products = params.data.details

                        const total = products.reduce((totalFullCommit, item) => totalFullCommit + item.base_qty, 0)
                        const committed = products.reduce((committed, item) => committed + item.committed_qty, 0)

                        let badge = {
                            color: 'grey',
                            text: 'Uncommitted'
                        }

                        if(committed && (committed == total)) {
                            badge.color = 'success'
                            badge.text = 'Fully Committed'
                        } else if(committed && (committed != total)) {
                            badge.color = 'warning'
                            badge.text = 'Partially Committed'
                        }

                        return `
                            <span class="px-2 py-3 text-sm font-semibold text-white bg-${badge.color} rounded-full">${badge.text}</span>
                        `
                    },
                    filter: true,
                    flex: 0.1,
                }
            ];
        },
    };
</script>

<style>
    .ag-theme-material .ag-cell {
        white-space: normal !important;
    }

    .hover_opacity-50 {
        transition: 0.25s;
    }

    .hover_opacity-50:hover {
        opacity: 0.5;
        transition: 0.25s;
    }
</style>